import React from 'react'
import '../../styles/components/NavBarDropdowns.scss'

const Adhd = (props) => {
  return (
    <div className='Adhd dropdown'>
      <ul className='Adhd__list'>
        <li className='Adhd__list-item'>Adderal</li>
        <li className='Adhd__list-item'>Modafnil</li>
        <li className='Adhd__list-item'>Ritalin</li>
      </ul>
    </div>
  )
}
 
export default Adhd;